"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16"
}, _react.default.createElement("path", {
  d: "M7.53 0a.5.5 0 00-.5.5v6.46H4.5a.5.5 0 00-.37.84l4.6 5.02a.5.5 0 00.74-.01l4.4-5.02a.5.5 0 00-.38-.83h-2.32V.5a.5.5 0 00-.5-.5H7.53zm.5 7.46V1h2.15v6.46c0 .28.22.5.5.5h1.72l-3.3 3.77-3.46-3.77h1.89a.5.5 0 00.5-.5zM2 10.39a.5.5 0 00-1 0v4.1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4.1a.5.5 0 00-1 0v4.1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-4.1z"
}));

exports.default = _default;